<template>
	<v-dialog
		v-model="modelLocal"
		:max-width="maxWidthOfPanel"
		:key="keyLocal"
		@click:outside="confirmSecondary"
	>
		<v-card class="dialogCard">
			<v-card-title>{{header}}</v-card-title>
			<v-card-text>{{body}}</v-card-text>
			<confirm-reject-btns
				@confirmed="confirmPrimary"
				@rejected="confirmSecondary"
			/>
		</v-card>
	</v-dialog>
</template>

<script>
import ConfirmRejectBtns from '../../components/arcCustom/ConfirmRejectBtns.vue'

export default {
	name: 'DialogBeforeAction',
	components: {
		ConfirmRejectBtns
	},
	props: {
		maxWidthOfPanel: {
			type: Number,
			default: 400,
		},
		model: {
			type: Boolean,
			required: true,
			default: true,
		},
		header: {
			type: String,
			default: '',
		},
		body: {
			type: String,
			default: '',
		},
		payload: {
			default: '',
		},
	},
	data() {
		return {
			modelLocal: this.model,
			payloadLocal: this.payload,
			keyLocal: 0,
		}
	},
	watch: {
		modelLocal: {
			handler() {
				this.keyLocal += 1
			},
		},
	},
	methods: {
		confirmPrimary() {
			this.modelLocal = false
			this.$emit('primaryConfirmed', this.payloadLocal)
		},
		confirmSecondary() {
			this.modelLocal = false
			this.$emit('secondaryConfirmed', this.payloadLocal)
		},
	},
}
</script>

<style lang="scss">
@import '../../../src/assets/scss/styling';

.dialogCard{
	padding: 25px !important;
}

</style>
